import React from "react";
import styles from "./styles.css";
import safetyImage from "../../shared/images/covid-assets/safety-image.png";
import IconProtect from "../../shared/images/cars24-protect-with-blue-text.svg";
import BreadcrumbTextTitle from "../../shared/breadcrumb-text-title";

const CovidLandingHeader = () => {
    return (
        <div styleName={"styles.covidSection"}>
            <div className={"container"}>
                <BreadcrumbTextTitle title={"Covid Safety Measures"} />
                <div className={"row"}>
                    <div className={"col-7"}>
                        <h3>
                            <img src={IconProtect} alt="icon-covid" />
                            Sell your car <br />the safer way
                        </h3>
                        <p>
                            In the light of government guidelines and to ensure the utmost
                            safety of our customers, we at CARS24 have taken the necessary
                            precautions to offer you the finest car selling
                            experience with world-class safety.
                        </p>
                    </div>
                </div>
            </div>
            <img src= {safetyImage} styleName={"styles.headerGraphic"} alt="safety image"/>

        </div>
    );
};

export default CovidLandingHeader;
